import * as React from 'react'

import { Controller } from 'react-hook-form'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import LocationParentPicker from '../../LocationPicker/LocationParentPicker'
import { ParentFieldConfig } from '../types'

interface ParentFieldProps {
  field: ParentFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
}

const ParentField: React.FC<ParentFieldProps> = ({
  field,
  control,
  error,
  hideHelperText,
}) => (
  <Controller
    name={field.name}
    control={control}
    defaultValue={field.defaultValue}
    rules={{
      required: field.required
        ? Localization.translator.requiredFieldCannotBeEmpty
        : false,
    }}
    render={({ field: { onChange, value } }) => (
      <LocationParentPicker
        className="tw:overflow-hidden"
        label={field.label || field.name}
        labelTooltip={field.labelTooltip}
        value={value}
        onChange={onChange}
        objectId={field.objectId}
        isRequired={field.required}
        isReadOnly={field.readOnly || field.displayOnly}
        isDisabled={field.disabled}
        isClearDisabled={field.disabled || field.displayOnly}
        isValid={!error}
        validationMessage={error}
        isHelperTextHidden={hideHelperText}
        isTopMarginForced
      />
    )}
  />
)

export default ParentField
